import {
  RequestIdentifier
} from '../../request';


/**
 * Responsible for making a request to the "inject" 
 */
 export interface IClientTransport {
  request(rpcName: string, argument: [string:any]): Promise<any>
}


/**
 * The actual parameters passed into all these functions
 */
 export type RequestStartedParameters = { id: RequestIdentifier, request: Request }
 export type RequestSucceededParameters = { id: RequestIdentifier, response: Response }
 export type RequestFailedParameters = { id: RequestIdentifier, error: Error }
 export type RequestMetadataUpdatedParameters = { id: RequestIdentifier, metadata: { [key: string]: any} };
 
 export type RequestUpdatedEventName = 'succeeded' | 'failed' | 'enhanced'
 
 
 